import { render, staticRenderFns } from "./ServiceAdd.vue?vue&type=template&id=adbea5c2&"
import script from "./ServiceAdd.vue?vue&type=script&lang=ts&"
export * from "./ServiceAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports